export const ProgramDateTypeCodes = [
  'Nomination-Window',
  'Scrubbing-Window',
  'Judging-Window',
  'Review-&-Designate-Window',
  'Compliance-&-Revisions-Window',
  'Winners-Window'
] as const;

export type ProgramDateTypeCode = typeof ProgramDateTypeCodes[number];

export interface ProgramDate {
  programDateId: number;
  programId: number;
  displayName: string;
  dateTypeCode: ProgramDateTypeCode;
  startDate: string;
  endDate: string;
  displayStartDate: string;
  displayEndDate: string;
}

export function blankProgramDate(programId: number, dateTypeCode: ProgramDateTypeCode): ProgramDate {
  return {
    programDateId: 0,
    programId,
    displayName: dateTypeCode.replace('-', ' '),
    dateTypeCode,
    startDate: '',
    endDate: '',
    displayStartDate: '',
    displayEndDate: ''
  }
}
